var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-full",class:{'mx-auto': _vm.center},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.icon.viewBox}},_vm._l((_vm.icon.elements),function(element,index){return _c(`vc-${element.type}`,{key:index,tag:"component",attrs:{"data":element.data}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }